import React from "react";
import notfound from "../../assets/componentAssets/notfound.svg";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function PageNotFound() {
  let navigate = useNavigate();
  return (
    <div
      style={{
        margin: "20px auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div>
        <img src={notfound} style={{ width: "100%" }} />
      </div>
      <h2 style={{ margin: "0px" }}>Page not found</h2>
      <Button
        sx={{
          background: "linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
          padding: "10px 20px",
          marginTop: "50px",
        }}
        variant="contained"
        onClick={() => navigate("/")}
      >
        Back to Panel
      </Button>
    </div>
  );
}

export default PageNotFound;
